module.exports = __webpack_public_path__ + "img/parthner-7.d03e31a6.svg";